/**
 * Creates all necessary objects for the given namespace
 *
 *     Ofcs.Namespace('Ofcs.Editor.Canvas');
 *
 *     Ofcs.Editor.Canvas.GuideManager = Ofcs.Object.extend({
 *         // ...
 *     });
 *
 * @method
 * @member Ofcs
 * @param {string} ns Dot separated namespace path
 */
export default function namespace(ns) {
    let context = window;
    const parts = ns.split('.');

    for (let i = 0; i < parts.length; i += 1) {
        context[parts[i]] = context[parts[i]] || {};
        context = context[parts[i]];
    }
}
